import { X } from "lucide-react";
import { toast } from "@/lib/toast";
import { getChannelMeta, notificationTitle } from "@/lib/inboundNotifications";

/**
 * Interactive inbound toast — click opens the conversation.
 */
export function showInboundToast(notification, onOpen) {
  const title = notificationTitle(notification);
  const meta = getChannelMeta(notification.channel);
  toast.custom(
    (t) => (
      <div
        className="relative w-full text-left rounded-lg border border-slate-200 bg-white shadow-lg px-3.5 py-3 pr-8 hover:border-slate-300 transition-colors"
        data-testid={`inbound-toast-${notification.id}`}
      >
        <button
          type="button"
          className="w-full text-left outline-none"
          onClick={() => {
            toast.dismiss(t);
            onOpen(notification);
          }}
        >
          <div className="flex items-start gap-2.5">
            <span className={`mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${meta.iconBg}`}>
              <meta.Icon size={14} strokeWidth={1.75} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-[13px] font-semibold text-slate-900 leading-snug">{title}</div>
              {notification.preview ? (
                <div className="mt-0.5 text-[12px] text-slate-600 line-clamp-2 leading-relaxed">
                  {notification.preview}
                </div>
              ) : null}
              <div className="mt-1.5 text-[11px] font-medium text-indigo-600">Open conversation</div>
            </div>
          </div>
        </button>
        <button
          type="button"
          className="absolute top-2 right-2 p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded transition-colors outline-none"
          onClick={(e) => {
            e.stopPropagation();
            toast.dismiss(t);
          }}
          aria-label="Dismiss"
          data-testid="inbound-toast-dismiss"
        >
          <X size={14} />
        </button>
      </div>
    ),
    { id: `inbound-notif-${notification.id}`, duration: 8000 },
  );
}
